<template>
  <div class="row dvContent">
    <BodyLoader :loading="firstLoad"></BodyLoader>

    <div class="dvModals">
      <div id="modal-reassign-team" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Reassign to Team
          </div>
          <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll" href="javascript:void(0)"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Member</label>
                <input v-model="reassingMember.name" class="browser-default defaultModal-input" readonly type="text" />

              </div>
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Team</label>
                <select class="browser-default defaultModal-input" v-model="reassingMember.team_id">
                  <option value="" disabled selected>Select from list</option>
                  <option v-for="(team, index) in defaultTeams" :key="index" :value="team.id">{{ team.name }}</option>
                </select>
                <div class="defaultModal-helper-text"></div>
              </div>
            </div>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">
          <a
            v-if="!reassignTeam"
            @click="doReassign()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check"></span>Reassign
          </a>

          <a
            v-if="reassignTeam"
            href="javascript:void(0)"
            :class="{ disabled: true }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            Reassigning...
          </a>

          <a
            @click="closeModal('modal-reassign-team')"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>
        </div>
      </div>

      <div id="modal-assign-email" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Assign Email
          </div>
          <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll" href="javascript:void(0)"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Account Name</label>
                <input v-model="assignEmailTo.name" class="browser-default defaultModal-input" readonly type="text" />
              </div>
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Email Address</label>
                <input v-model="assignEmailTo.email" class="browser-default defaultModal-input" placeholder="e.g. juan.delacruz@ayalaland-intl.com" type="text" />
                <div class="defaultModal-helper-text">
                  * Required (Please enter a valid ALI email address)
                </div>
              </div>
            </div>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">
          <a
            v-if="!saving"
            @click="assignEmail()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check"></span>Save
          </a>

          <a
            v-if="saving"
            href="javascript:void(0)"
            :class="{ disabled: true }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            Saving...
          </a>

          <a
            href="javascript:void(0)" class="modal-close waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>
        </div>
      </div>
      <!-- modal-->
    </div>

    <div class="col dvResultsContentMain">
      <SearchResultNav :q="q"></SearchResultNav>

      <div class="row dvResultsContent forTeams">
        <div class="dvResultsBar">
          Found <strong>{{ pager.totalRecords }}</strong> result {{ pager.totalRecords > 1 ? 's' : '' }} for <strong>"{{q}}"</strong> in Members
        </div><!-- dvResultsBar -->
        <div class="col s12 dvContentMain">

          <div class="dvCards-container">
            <div
              v-show="pager.totalRecords == 0 && !loading"
              class="dvBlankSection">
              <div class="dvBlankSectionBox flexCenterAll">
                <div class="dvBlankSection-content">
                  <div class="dvBlankSection-icon flexCenterAll"><i class="material-icons">find_in_page</i></div>
                  <div class="dvBlankSection-text-primary center-align">
                    There are no members to display
                  </div>
                  <div class="dvBlankSection-text-secondary center-align">
                    Try using the search box above to find what you are looking for.
                  </div>
                </div>
              </div>
            </div>
            <ContentLoader :loading="true" :firstLoad="firstLoad"></ContentLoader>

            <div class="row" v-if="$getConstRole('ROLE_SELLER') == $store.getters.getCurrentUserRole || $getConstRole('ROLE_MANAGER') == $store.getters.getCurrentUserRole">
              <div
                v-for="(member, index) in members" :key="index"
                class="col s12 m12 l6 xl4">
                <div class="dvCardClient">
                  <div class="dvCardClient-header">
                    <div class="dvCardClient-header-name">

                      <div class="dvCardProfile-image">
                        <div class="dvCardProfile-image-placer flexCenterAll"><div><span class="icon-fs_user"></span></div></div>
                        <img class="dvCardProfile-image-pic responsive-img" :src="member.photo" v-show="member.photo && member.photo.length > 0"/>
                      </div>

                      <div class="dvCardClient-header-name-info">
                        {{ $store.getters.formatFullName(member.first_name, member.last_name) || member.email }}
                        <div class="dvCardClient-header-name-info-label">{{ member.position }}</div>
                      </div> <!-- dvCardClient-header-name-info -->
                    </div> <!-- dvCardClient-header-name -->

                    <div
                      v-if="$getConstRole('ROLE_MANAGER') == $store.getters.getCurrentUserRole"
                      class="dvCardClient-header-menu">

                      <a
                        :name="'card-box-menu-'+index"
                        :ref="'tippy_menu'+index"
                        class="waves-effect waves-light dvCardClient-header-link flexCenterAll" href="javascript:void(0)"><span class="icon-nav_more_horz"></span></a>

                      <tippy
                       v-bind:to="'card-box-menu-'+index"
                       placement="bottom-end"
                       offset="[10, 2]"
                       interactive
                       arrow
                       trigger="click">
                       <div class="morePopMenuBox-content ">

                         <router-link
                           class="morePopMenuBox-content-item"
                           :to="{ name:'team_member', params: { id: member.id, status: 'valid' } }">
                           <span class="icon-editor_view"></span>View
                         </router-link>

                         <router-link
                          v-if="member.pending > 0"
                           class="morePopMenuBox-content-item"
                           :to="{ name:'team_member_resolve', params: { id: member.id, referral_id: 'all' } }">
                           <span class="icon-action_check"></span>Resolve
                         </router-link>

                         <a
                         @click="confirm({
                           id: member.id,
                           type: 'remove-member'
                         })"
                         href="javascript:void(0)" class="morePopMenuBox-content-item">
                           <span class="icon-action_delete"></span>Remove
                         </a>

                       </div>
                     </tippy>

                    </div> <!-- dvCardClient-header-menu -->
                  </div> <!-- dvCardClient-header -->
                  <div class="dvCardClient-content">
                    <div class="dvCardClient-content-items">
                      <div
                        v-if="$getConstRole('ROLE_SELLER') == $store.getters.getCurrentUserRole"
                        disabled class="waves-effect waves-light dvCardClient-content-items-link">
                        <div>Valid</div>
                        <div class="dvCardClient-count bgValid">{{ member.valid }}</div>
                      </div> <!-- dvCardClient-content-items-link -->
                      <div
                        v-if="$getConstRole('ROLE_SELLER') == $store.getters.getCurrentUserRole"
                        disabled class="waves-effect waves-light dvCardClient-content-items-link">
                        <div>Pending</div>
                        <div class="dvCardClient-count bgPending">{{ member.pending }}</div>
                      </div> <!-- dvCardClient-content-items-link -->
                      <div
                        v-if="$getConstRole('ROLE_SELLER') == $store.getters.getCurrentUserRole"
                        disabled class="waves-effect waves-light dvCardClient-content-items-link">
                        <div>Expiring</div>
                        <div class="dvCardClient-count bgExpiring">{{ member.expiring }}</div>
                      </div> <!-- dvCardClient-content-items-link -->


                      <router-link
                        v-if="$getConstRole('ROLE_MANAGER') == $store.getters.getCurrentUserRole"
                        class="waves-effect waves-light dvCardClient-content-items-link"
                        :to="{ name:'team_member', params: { id: member.id, status: 'valid' } }">
                        <div>Valid</div>
                        <div class="dvCardClient-count bgValid">{{ member.valid }}</div>
                      </router-link>

                      <router-link
                        v-if="$getConstRole('ROLE_MANAGER') == $store.getters.getCurrentUserRole"
                        class="waves-effect waves-light dvCardClient-content-items-link"
                        :to="{ name:'team_member', params: { id: member.id, status: 'pending' } }">
                        <div>Pending</div>
                        <div class="dvCardClient-count bgPending">{{ member.pending }}</div>
                      </router-link>

                      <router-link
                        v-if="$getConstRole('ROLE_MANAGER') == $store.getters.getCurrentUserRole"
                        class="waves-effect waves-light dvCardClient-content-items-link"
                        :to="{ name:'team_member', params: { id: member.id, status: 'expiring' } }">
                        <div>Expiring</div>
                        <div class="dvCardClient-count bgExpiring">{{ member.expiring }}</div>
                      </router-link>

                      <div
                        v-if="$getConstRole('ROLE_MANAGER') == $store.getters.getCurrentUserRole"
                        class="dvCardClient-content-items-label"><span class="icon-content_activity"></span>{{ member.last_activity }}</div>
                    </div> <!-- dvCardClient-content-items -->

                    <div
                      v-if="$getConstRole('ROLE_SELLER') == $store.getters.getCurrentUserRole"
                      class="row dvCardClient-content-action">
                      <div class="col s12">
                        <a
                          :disabled="userDetails.id == member.id"
                          :href="'mailto:'+member.email" class="waves-effect waves-dark btn-RoundCorners"><span class="icon-content_email"></span><div class="label">Contact</div></a>
                      </div> <!-- col -->
                    </div> <!-- dvCardClient-content-action -->
                    <div
                      v-if="$getConstRole('ROLE_MANAGER') == $store.getters.getCurrentUserRole"
                      class="row dvCardClient-content-action">
                      <div class="col s12 m6">
                        <div
                          v-if="member.pending == 0"
                          class="waves-effect waves-light btn-RoundCorners isResolve isDisabled">
                          <div class="label">Resolve</div>
                        </div>
                        <router-link
                          v-if="member.pending > 0"
                          :to="{ name:'team_member_resolve', params: { id: member.id, referral_id: 'all' } }"
                          href="javascript:void(0)"
                          class="waves-effect waves-light btn-RoundCorners isResolve">
                          <div class="label">Resolve</div>
                          <div class="dvCardClient-count">{{ member.pending }}</div>
                        </router-link> <!-- RoundCorners -->
                      </div> <!-- col -->
                      <div class="col s12 m6">
                        <a
                          :disabled="userDetails.id == member.id"
                          :href="'mailto:'+member.email" class="waves-effect waves-dark btn-RoundCorners"><span class="icon-content_email"></span><div class="label">Contact</div></a>
                      </div> <!-- col -->
                    </div> <!-- dvCardClient-content-action -->
                  </div> <!-- dvCardClient-content -->
                </div> <!-- dvCardClient -->
              </div> <!-- col -->

            </div>


            <div class="row" v-if="$getConstRole('ROLE_SUB_ADMIN') == $store.getters.getCurrentUserRole">
              <div
                v-for="(member, index) in members" :key="index"
                class="col s12 m12 l6 xl4">
                <div class="dvCardClient" :class="{ 'member-unassigned': $store.getters.isTemporaryEmail(member.email) }">
                  <div class="dvCardClient-header">
                    <div class="dvCardClient-header-name">

                      <div class="dvCardProfile-image">
                        <div class="dvCardProfile-image-placer flexCenterAll">
                          <div>
                            <span class="icon-fs_user" v-show="!$store.getters.isTemporaryEmail(member.email)"></span>
                            <span class="icon-action_help" v-show="$store.getters.isTemporaryEmail(member.email)"></span>
                          </div>
                        </div>
                        <img class="dvCardProfile-image-pic responsive-img" :src="member.photo" v-show="member.photo && member.photo.length > 0"/>
                      </div>

                      <div class="dvCardClient-header-name-info">
                        {{ $store.getters.formatFullName(member.first_name, member.last_name) || member.email }}
                        <div class="dvCardClient-header-name-info-label">{{ member.position }}</div>
                      </div> <!-- dvCardClient-header-name-info -->
                    </div> <!-- dvCardClient-header-name -->

                    <div
                      class="dvCardClient-header-menu">

                      <a
                        :name="'card-box-menu-'+index"
                        :ref="'tippy_menu'+index"
                        class="waves-effect waves-light dvCardClient-header-link flexCenterAll" href="javascript:void(0)"><span class="icon-nav_more_horz"></span></a>

                      <tippy
                       v-bind:to="'card-box-menu-'+index"
                       placement="bottom-end"
                       offset="[10, 2]"
                       interactive
                       arrow
                       trigger="click">
                       <div class="morePopMenuBox-content" v-show="!$store.getters.isTemporaryEmail(member.email)">

                         <router-link
                           class="morePopMenuBox-content-item"
                           :to="{ name:'admin_team_member', params: { id: member.id, team_id: member.team_id, status: 'valid' } }">
                           <span class="icon-editor_view"></span>View
                         </router-link>

                         <router-link
                          v-if="member.pending > 0"
                           class="morePopMenuBox-content-item"
                           :to="{ name:'admin_team_member_resolve', params: { id: member.id, team_id: member.team_id, referral_id: 'all' } }">
                           <span class="icon-action_check"></span>Resolve
                         </router-link>

                         <a
                          @click="showReassignModal(member)"
                         href="javascript:void(0)" class="morePopMenuBox-content-item">
                           <i class="material-icons">swap_horiz</i>Reassign to Team
                         </a>

                         <a
                          v-if="member.role == $getConstRole('ROLE_MANAGER')"
                          @click="confirm({
                           id: member.id,
                           team_id: member.team_id,
                           type: 'remove-as-manager',
                           name: $store.getters.formatFullName(member.first_name, member.last_name) || member.email
                         })"
                         href="javascript:void(0)" class="morePopMenuBox-content-item">
                           <i class="material-icons">cancel</i>Remove as Manager
                         </a>

                         <a
                          v-if="member.role == $getConstRole('ROLE_SELLER')"
                          @click="confirm({
                           id: member.id,
                           team_id: member.team_id,
                           type: 'assign-as-manager',
                           name: $store.getters.formatFullName(member.first_name, member.last_name) || member.email
                         })"
                         href="javascript:void(0)" class="morePopMenuBox-content-item">
                           <span class="icon-action_star"></span>Assign as Manager
                         </a>

                         <a
                          v-if="member.status == 2"
                          @click="confirm({
                           id: member.id,
                           type: 'activate-member',
                           name: $store.getters.formatFullName(member.first_name, member.last_name) || member.email
                         })"
                         href="javascript:void(0)" class="morePopMenuBox-content-item">
                           <i class="material-icons">check_circle</i>Activate
                         </a>

                         <a
                          v-if="member.status == 1"
                          @click="confirm({
                           id: member.id,
                           type: 'disable-member',
                           name: $store.getters.formatFullName(member.first_name, member.last_name) || member.email
                         })"
                         href="javascript:void(0)" class="morePopMenuBox-content-item">
                           <i class="material-icons">block</i>Disable
                         </a>

                         <a
                         @click="confirm({
                           id: member.id,
                           type: 'remove-member'
                         })"
                         href="javascript:void(0)" class="morePopMenuBox-content-item">
                           <i class="material-icons">cancel</i>Remove
                         </a>

                         <a
                         @click="confirm({
                           id: member.id,
                           type: 'reset-password'
                         })"
                         href="javascript:void(0)" class="morePopMenuBox-content-item">
                           <i class="material-icons">person</i>Reset Password
                         </a>

                         <a
                           @click="openModalAssignEmail(member)"
                           href="javascript:void(0)" class="morePopMenuBox-content-item">
                           <i class="material-icons">person</i>Assign Email
                         </a>

                       </div>
                       <div class="morePopMenuBox-content" v-show="$store.getters.isTemporaryEmail(member.email)">
                         <a
                           @click="openModalAssignEmail(member)"
                           href="javascript:void(0)" class="morePopMenuBox-content-item">
                           <i class="material-icons">person</i>Assign Email
                         </a>
                       </div>
                     </tippy>

                    </div> <!-- dvCardClient-header-menu -->
                  </div> <!-- dvCardClient-header -->
                  <div class="dvCardClient-content">
                    <div class="dvCardClient-content-items">
                      <router-link
                        class="waves-effect waves-light dvCardClient-content-items-link"
                        :to="{ name:'admin_team_member', params: { id: member.id, team_id: member.team_id, status: 'valid' } }">
                        <div>Valid</div>
                        <div class="dvCardClient-count bgValid">{{ member.valid }}</div>
                      </router-link>

                      <router-link
                        class="waves-effect waves-light dvCardClient-content-items-link"
                        :to="{ name:'admin_team_member', params: { id: member.id, team_id: member.team_id, status: 'pending' } }">
                        <div>Pending</div>
                        <div class="dvCardClient-count bgPending">{{ member.pending }}</div>
                      </router-link>

                      <router-link
                        class="waves-effect waves-light dvCardClient-content-items-link"
                        :to="{ name:'admin_team_member', params: { id: member.id, team_id: member.team_id, status: 'expiring' } }">
                        <div>Expiring</div>
                        <div class="dvCardClient-count bgExpiring">{{ member.expiring }}</div>
                      </router-link>

                      <div v-show="!$store.getters.isTemporaryEmail(member.email)" class="dvCardClient-content-items-label"><span class="icon-content_activity"></span>{{ member.last_activity }}</div>
                      <div v-show="$store.getters.isTemporaryEmail(member.email)" class="dvCardClient-content-items-label"><span class="icon-action_help"></span>No assigned email</div>
                    </div> <!-- dvCardClient-content-items -->

                    <div
                      class="row dvCardClient-content-action">
                      <div class="col s12 m6">
                        <div
                          v-if="member.pending == 0"
                          class="waves-effect waves-light btn-RoundCorners isResolve isDisabled">
                          <div class="label">Resolve</div>
                        </div>
                        <router-link
                          v-if="member.pending > 0"
                          :to="{ name:'admin_team_member_resolve', params: { id: member.id, team_id: member.team_id, referral_id: 'all' } }"
                          href="javascript:void(0)"
                          class="waves-effect waves-light btn-RoundCorners isResolve">
                          <div class="label">Resolve</div>
                          <div class="dvCardClient-count">{{ member.pending }}</div>
                        </router-link> <!-- RoundCorners -->
                      </div> <!-- col -->
                      <div class="col s12 m6">
                        <a :href="'mailto:'+member.email" class="waves-effect waves-dark btn-RoundCorners"><span class="icon-content_email"></span><div class="label">Contact</div></a>
                      </div> <!-- col -->
                    </div> <!-- dvCardClient-content-action -->
                  </div> <!-- dvCardClient-content -->
                </div> <!-- dvCardClient -->
              </div> <!-- col -->

            </div> <!-- row -->



          </div>

        </div>
      </div><!--  dvResultsContent forTeams-->

    </div> <!-- dvResultsContentMain -->

    <div class="col s12 dvContentTools">
      <div class="dvContentTools-fx"></div>
      <div class="dvContentTools-content">
        <a
          :class="{ disabled: (pager.currentPage < 2 || loading) ? true : false }"
          @click="previousPage()"
          href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools isPagination flexCenterAll">
          <span class="icon-nav_chevron_left"></span>Previous
        </a>
<!--  -->
        <div class="dvContentTools-pagination">
          <form id="frmChangePassword" @submit.prevent="setPage">
            <input
              type="text" class="browser-default" v-model="pager.currentPage" />
          </form>
          <div class="dvContentTools-pagination-label">of {{ pager.totalPages }}</div>
          <!-- <div class="dvContentTools-pagination-label">{{ pager.dataStart }} of {{ pager.totalRecords }}</div> -->
        </div>

        <a
          :class="{ disabled: !pager.hasNext || loading }"
          @click="nextPage()"
          href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools isPagination flexCenterAll">
          Next<span class="icon-nav_chevron_right"></span>
        </a>
      </div>
      <div class="dvContentTools-page">
        <a href="#" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-content_email"></span><div class="hide-on-small-only">Email</div></a>
        <a href="#" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-action_print"></span><div class="hide-on-small-only">Print</div></a>
        <ToTop></ToTop>
      </div>
    </div>

    <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
    <ConfirmationDialog
      :dialog="dialog"
      @doConfirm="doConfirm">
    </ConfirmationDialog>

  </div> <!-- dvContent -->
</template>

<script>
  import BodyLoader from '@/components/BodyLoader.vue'
  import SearchResultNav from './SearchResultNav.vue'
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import ConfirmationDialog from '@/components/confirmation_view/ConfirmationDialog.vue'
  import ContentLoader from '@/components/ContentLoader.vue'
  import M from 'materialize-css'
  import ToTop from '@/components/totop/ToTop.vue'

  export default {
    name: 'search-result-members',
    data: () => ({
      saving: false,
      assignEmailTo: {
        id: '',
        name: '',
        email: ''
      },
      q: '',
      members: [],
      filter_by: '',
      dialog: {
        show: false,
        title: '',
        body: '',
        action: '',
        id: ''
      },
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      pager: {
        currentPage: 1,
        perPage: 9,
        hasNext: 0,
        totalRecords: 0,
        totalPages: 0,
        dataStart: 0
      },
      loading: false,
      firstLoad: true,
      noRecordFound: false,
      userDetails: {},
      teamTomove: '',
      reassignTeam: false,
      reassingMember: {
        id: '',
        name: '',
        team_id: ''
      },
      defaultUsers: [],
      defaultChannels: [],
      defaultTeams: []
    }),
    watch: {
      $route (to, from){
        let q = to.query.q
        this.q = q
        this.pager.currentPage = 1
        this.search()
      }
    },
    computed: {
    },
    methods: {
      resetPassword (member){
        this.$http.secured.post('/api/members/reset-password/'+ member)
          .then(response => {
            this.showMessage(response.data.message, 'sb-success')
          })
          .catch(error => {
            if (error.response) {
              let errors = error.response.data.messages
              let msg = []
              Object.keys(errors).forEach(key => {
                msg.push(errors[key])
              })
              this.showMessage(msg.join(','), 'sb-failed')

            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }
          })
      },
      closeModal (str){
        const elem = document.getElementById(str);
        const instance = M.Modal.init(elem, {dismissible: false});
        instance.close();

        // let team_name = this.team.team_name
        // this.team_name = team_name
        //
        // let team_target_referrals = this.team.team_target_referrals
        // this.team_target_referrals = team_target_referrals
        //
        // this.memberData.email = ''
        // this.printSendTo = ''
      },
      doReassign () {
        if(this.reassignTeam){
          return false;
        }
        this.reassignTeam = true
        let self = this

        this.$http.secured.post('/api/members/reassign/'+ this.reassingMember.id + '/' + this.reassingMember.team_id)
          .then(response => {
            this.search()
            this.showMessage(response.data.message, 'sb-success')
            this.closeModal('modal-reassign-team')
            this.teamTomove = ''
          })
          .catch(error => {
            if (error.response) {
              let errors = error.response.data.messages
              let msg = []
              Object.keys(errors).forEach(key => {
                msg.push(errors[key])
              })

              this.showMessage(msg.join(','), 'sb-failed')

            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }
          })
          .then(function () {
            self.reassignTeam = false
          })
      },
      showReassignModal (member) {
        let reassingMember = {
          id: member.id,
          name: this.$store.getters.formatFullName(member.first_name, member.last_name) || member.email,
          team_id: member.team_id
        }
        this.reassingMember = reassingMember
        this.openModalTeam('modal-reassign-team')
      },
      openModalTeam (str){
        document.querySelectorAll('.tippy-popper').forEach(popper => {
          popper._tippy.hide()
        })

        const elem = document.getElementById(str);
        const instance = M.Modal.init(elem, {dismissible: false});
        instance.open();
      },
      assignEmail (){
        if(this.saving){
          return false
        }

        let self = this
        self.saving = true

        this.$http.secured.post('api/members/assign-email', this.assignEmailTo)
          .then(response => {
            this.closeModal('modal-assign-email')
            this.showMessage(response.data.message, 'sb-success')
            this.getMembers()
          })
          .catch(error => {
            if (error.response) {
              let errors = error.response.data.messages
              let msg = []
              Object.keys(errors).forEach(key => {
                msg.push(errors[key])
              })

              this.showMessage(msg.join(','), 'sb-failed')

            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }
          })
          .then(function () {
            self.saving = false
          })
      },
      openModalAssignEmail (member){
        document.querySelectorAll('.tippy-popper').forEach(popper => {
          popper._tippy.hide()
        })

        this.assignEmailTo.id = member.id
        this.assignEmailTo.name = this.$store.getters.formatFullName(member.first_name, member.last_name)
        this.assignEmailTo.email = ''

        if (!this.$store.getters.isTemporaryEmail(member.email)) {
          this.assignEmailTo.email = member.email
        }

        const elem = document.getElementById('modal-assign-email');
        const instance = M.Modal.init(elem, {dismissible: false});
        instance.open();
      },
      search (){
        if(this.loading){
          return false;
        }

        if(this.q == ''){
          this.showMessage('The keyword field is required.', 'sb-failed')
          return false
        }

        let self = this
        this.loading = true
        this.noRecordFound = false
        this.selected = [];
        this.members = [];
        let url = 'api/search/members?q='+this.q+'&page='+this.pager.currentPage+'&per_page='+this.pager.perPage

        this.$http.plain.get(url)
          .then(response => {

            // let referrals = response.data.referrals
            // for (let i = 0; i < referrals.length; i++){
            //   referrals[i].selected = false
            //   this.referrals.push(referrals[i])
            // }


            this.members = response.data.members;

            if(this.members.length == 0){
              this.noRecordFound = true
            }

            this.pager.hasNext = response.data.pager.has_next_page
            this.pager.totalRecords = response.data.pager.total_records
            this.pager.dataStart = response.data.pager.data_start
            this.pager.totalPages = response.data.pager.total_pages
            // document.getElementById("toFocus").focus();
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
          .then(function () {
            self.loading = false
            self.firstLoad = false
            self.$emit('firstLoadDone')
          })
        },
        replacePhoto (photo){
          this.team.photo = photo
        },
        confirm (action){
          document.querySelectorAll('.tippy-popper').forEach(popper => {
            popper._tippy.hide()
          })

          if(action.type == 'remove-member'){
            this.dialog = {
              show: true,
              title: 'Are you sure you want to remove this?',
              body: 'You can\'t undo this action.',
              icon: 'icon-action_delete',
              positionBtn: 'Remove',
              negativeBtn: 'Cancel',
              actionType: action.type,
              id: action.id
            }
          }else if(action.type == 'activate-member'){
            this.dialog = {
              show: true,
              title: 'Are you sure you want to activate '+action.name+'?',
              body: '',
              icon: 'check_circle',
              icon_material: true,
              positionBtn: 'Activate',
              negativeBtn: 'Cancel',
              actionType: action.type,
              id: action.id
            }
          }else if(action.type == 'disable-member'){
            this.dialog = {
              show: true,
              title: 'Are you sure you want to disable '+action.name+'?',
              body: '',
              icon: 'block',
              icon_material: true,
              positionBtn: 'Disable',
              negativeBtn: 'Cancel',
              actionType: action.type,
              id: action.id
            }
          }else if(action.type == 'remove-as-manager'){
            this.dialog = {
              show: true,
              title: 'Are you sure you want to remove '+action.name+' as manager?',
              body: '',
              icon: 'icon-action_delete',
              positionBtn: 'Remove',
              negativeBtn: 'Cancel',
              actionType: action.type,
              id: action.id,
              team_id: action.team_id
            }
          }else if(action.type == 'assign-as-manager'){
            this.dialog = {
              show: true,
              title: 'Are you sure you want to assign '+action.name+' as manager?',
              body: '',
              icon: 'icon-action_star',
              positionBtn: 'Assign',
              negativeBtn: 'Cancel',
              actionType: action.type,
              id: action.id,
              team_id: action.team_id
            }
          }else if(action.type == 'reset-password'){
            this.dialog = {
              show: true,
              title: "Are you sure you want to reset the user's password?",
              body: '',
              icon: 'icon-fs_user',
              positionBtn: 'Reset',
              negativeBtn: 'Cancel',
              actionType: action.type,
              id: action.id
            }
          }

        },
        doConfirm (){
          this.dialog.show = false

          if(this.dialog.actionType == 'remove-member'){
            this.processRemoveMember(this.dialog.id)
          }else if(this.dialog.actionType == 'disable-member'){
            this.processDisableMember(this.dialog.id)
          }else if(this.dialog.actionType == 'activate-member'){
            this.processActivateMember(this.dialog.id)
          }else if(this.dialog.actionType == 'remove-as-manager'){
            this.removeTeamManager(this.dialog.id)
          }else if(this.dialog.actionType == 'assign-as-manager'){
            this.assignAsTeamManager(this.dialog.id)
          }else if(this.dialog.actionType == 'reset-password'){
            this.resetPassword(this.dialog.id)
          }
        },
        assignAsTeamManager (){
          this.$http.secured.post('/api/admin/teams/assign-as-manager/'+ this.dialog.team_id+'/'+this.dialog.id)
            .then(response => {
              this.search()
              this.showMessage(response.data.message, 'sb-success')
            })
            .catch(error => {
              this.showMessage(error, 'sb-failed')
            })
        },
        removeTeamManager (){
          this.$http.secured.post('/api/admin/teams/remove-manager/'+ this.dialog.team_id)
            .then(response => {
              this.search()
              this.showMessage(response.data.message, 'sb-success')
            })
            .catch(error => {
              this.showMessage(error, 'sb-failed')
            })
        },
        processDisableMember (id){
          this.$http.secured.post('api/members/disable/'+ id)
            .then(response => {
              this.showMessage(response.data.message, 'sb-success')
              this.search()
            })
            .catch(error => {
              this.showMessage(error, 'sb-failed')
            })
        },
        processActivateMember (id){
          this.$http.secured.post('api/members/activate/'+ id)
            .then(response => {
              this.showMessage(response.data.message, 'sb-success')
              this.search()
            })
            .catch(error => {
              this.showMessage(error, 'sb-failed')
            })
        },
        processRemoveMember (id){
          this.$http.secured.delete('api/members/'+ id)
            .then(response => {
              this.showMessage('Member has been successfully deleted', 'sb-success')
              this.search()
            })
            .catch(error => {
              this.showMessage(error, 'sb-failed')
            })
        },
        setPage (){
          if(this.pager.currentPage > this.pager.totalPages || this.pager.currentPage < 1){
            this.pager.currentPage = 1
          }

          this.search();
        },
        previousPage (){
          this.pager.currentPage--;
          this.search();
        },
        nextPage (){
          this.pager.currentPage++;
          this.search();
        },
        showMessage(msg, color){
          this.snackbarDetails = {
            color: color,
            msg: msg,
            show: true
          }
        },
        getDefaultData () {
          this.$http.plain.get('api/default-data')
            .then(response => {
              this.defaultUsers = response.data.users
              this.defaultChannels = response.data.channels
              this.defaultTeams = response.data.teams
            })
            .catch(error => {
              console.log(error);
            })
        }
    },
    mounted() {
      this.userDetails = this.$store.getters.getCurrentUserDetails
      this.q = this.$route.query.q
      this.search()
      this.getDefaultData()
      M.AutoInit()

    },
    components: {
      SnackBar,
      ConfirmationDialog,
      ContentLoader,
      SearchResultNav,
      BodyLoader,
      ToTop
    }
  }
</script>
